import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavItemType } from './models/nav-item-type.enum';
import { NavItemModel } from './models/nav-item.model';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
})
export class NavItemComponent implements OnInit {
  @Input() item?: NavItemModel;

  public itemType = NavItemType;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  isActive(navTo: string): boolean {
    return this.router.url.includes(navTo);
  }

  navigate(navigateTo: string): void {
    if (this.item?.isExternalLink) {
      window.location.href = navigateTo;
    } else {
      this.router.navigate([navigateTo]);
    }
  }
}
